import React from 'react';
import CameraCard from './CameraCard';
import './CameraGrid.css';

const CameraGrid = ({ cameras, columns }) => {
  // Отфильтровываем undefined или null камеры
  const validCameras = cameras.filter(cam => cam != null);
  
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: '20px'
  };

  return (
    <div className="camera-grid" style={gridStyle}>
      {validCameras.map((camera, idx) => (
        <CameraCard key={camera.id || idx} camera={camera} index={idx} />
      ))}
    </div>
  );
};

export default CameraGrid;